import React, { useCallback } from 'react';
import '../styles/custom-myles-styles.scss';
import { Card } from '@app/ui';
import PropTypes from 'prop-types';
import shortenStr from '../utils/shortenStr';
import Tooltip from '@app/ui/sports-components/Tooltip';
import { useTranslation } from 'react-i18next';

const SocialMediaLinkageCard = ({
    type = 'facebook',
    logo,
    revoked,
    _link,
    _unlink,
    name,
    altLogo = null,
}) => {
    const { t } = useTranslation('settings');
    const refresh = useCallback(async () => {
        const confirmation = confirm(
            t('clientConfiguration.social.linkageCard.refreshConfirm'),
        );
        if (!confirmation) return;
        await _unlink();
        await _link();
    }, [_unlink, _link, t]);

    const unlink = useCallback(async () => {
        const confirmation = confirm(
            t('clientConfiguration.social.linkageCard.unlinkConfirm'),
        );
        if (!confirmation) return;
        await _unlink();
    }, [_unlink, t]);

    const smallLogoClass =
        type === 'facebook'
            ? 'fa-facebook-square'
            : type === 'instagram'
              ? 'fa-instagram'
              : 'fa-x-twitter';

    return (
        <Card
            style={{ marginBottom: '0.75rem', width: '100%' }}
            styles={{ body: { padding: 0 } }}
        >
            <div className="gds-flex -p-h-2 -p-t-2 -p-b-1">
                <div className="gds-circular-thumbnail gds-circular-thumbnail--sm -m-r-3  -m-t-2">
                    <img
                        src={logo}
                        height="100%"
                        width="100%"
                        alt={name}
                        onError={e => {
                            e.target.src = altLogo;
                            e.target.onError = null;
                            e.target.style = 'padding: 0.7rem';
                        }}
                    />
                </div>
                <div
                    style={{
                        flex: '1 1 0%',
                        minWidth: '0px',
                        marginLeft: '0',
                    }}
                >
                    <Tooltip
                        text={name}
                        position="top"
                        style={{
                            top: revoked ? '2px' : '4px',
                        }}
                    >
                        <p className="gds-text--body-md gds-text--bold -ellipsis">
                            <i
                                className={`fa fab-fa6 ${smallLogoClass} -m-r-2`}
                            />
                            {revoked ? shortenStr(15, name) : name}
                        </p>
                    </Tooltip>

                    {revoked && (
                        <div className="-revoke-container">
                            <div
                                className="gds-tag gds-tag--danger gds-tag--xs"
                                style={{
                                    top: '2px',
                                }}
                            >
                                {t(
                                    'clientConfiguration.social.linkageCard.revoked',
                                )}
                            </div>
                        </div>
                    )}

                    <div
                        style={{
                            top: revoked ? '-4px' : '-4px',
                        }}
                    >
                        <a
                            onClick={unlink}
                            className=" social-linkage--link -cursor--pointer gds-text--body-md -m-r-2"
                        >
                            <i className="fas fa-unlink -m-r-2" />
                            {t('clientConfiguration.social.linkageCard.unlink')}
                        </a>
                        <p className="-inline-block -m-h-3">|</p>
                        <a
                            onClick={refresh}
                            className=" social-linkage--link  -cursor--pointer gds-text--body-md"
                        >
                            <i className="fas fa fa-refresh -m-r-2" />
                            {t(
                                'clientConfiguration.social.linkageCard.refresh',
                            )}
                        </a>
                    </div>
                </div>
            </div>
        </Card>
    );
};

SocialMediaLinkageCard.propTypes = {
    logo: PropTypes.string,
    type: PropTypes.string,
    revoked: PropTypes.bool,
    _unlink: PropTypes.func,
    _link: PropTypes.func,
    name: PropTypes.string,
    altLogo: PropTypes.string,
};

SocialMediaLinkageCard.defaultProps = {
    altLogo: null,
};

export default SocialMediaLinkageCard;
